import { AbstractModel } from ".";

export default class TribeLink extends AbstractModel {
  id!: number;
  shortUrl?: string;
  qrcodeUrl?: string;
}
